"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormTelefonos = FormTelefonos;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _style = _interopRequireDefault(require("./style"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FormTelefonos(props) {
  const {
    texto,
    titulo,
    open,
    onClose,
    onCancelar,
    onAceptar,
    botonAceptarTexto,
    botonCancelarTexto,
    invertirDestacado
  } = props;
  const theme = (0, _styles.useTheme)();
  const classes = (0, _style.default)(theme);
  return (0, _react2.jsx)(_material.Dialog, {
    open: open,
    onClose: onClose,
    "aria-labelledby": "dialog-title"
  }, titulo ? (0, _react2.jsx)(_material.DialogTitle, {
    id: "dialog-title"
  }, titulo) : null, (0, _react2.jsx)(_material.DialogContent, null, (0, _react2.jsx)(_material.DialogContentText, {
    id: "alert-dialog-description"
  }, texto)), (0, _react2.jsx)(_material.DialogActions, null, onCancelar ? (0, _react2.jsx)(_material.Button, {
    onClick: onCancelar,
    css: classes.colorCeleste,
    variant: invertirDestacado ? 'outlined' : 'text',
    color: "primary"
  }, botonCancelarTexto || 'Cancelar') : null, (0, _react2.jsx)(_material.Button, {
    onClick: onAceptar,
    css: classes.colorCeleste,
    autoFocus: true
  }, botonAceptarTexto || 'Aceptar')));
}

var _default = FormTelefonos;
exports.default = _default;